import React from "react";
//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

function CommingSoon() {
    AnimationFileLoader();

    return (
      <>

{/* Coming Soon */}
    <div className="py-5 d-flex align-items-center vh-100">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    {/* Card */}
                    <div className="card card-big">
                        <div className="card-body text-center coming-soon-content">
                            {/* Countdown */}
                            <ul className="countdown style--two">
                                <li>
                                    <h2 className="days">00</h2>
                                    <p>Day (s)</p>
                                </li>
                                <li>
                                    <h2 className="hours">00</h2>
                                    <p>Hour (s)</p>
                                </li>
                                <li>
                                    <h2 className="minutes">00</h2>
                                    <p>Minute (s)</p>
                                </li>
                                <li>
                                    <h2 className="seconds">00</h2>
                                    <p>Second (s)</p>
                                </li>
                            </ul>
                            {/* End Countdown */}

                            <img src="/img/media/coming-soon.png" className="coming-soon-img" alt=""/>

                            <form action="https://themelooks.us13.list-manage.com/subscribe/post?u=79f0b132ec25ee223bb41835f&id=f4e0e93d1d"
                                className="newslatter-form style--three">
                                <div className="theme-input-group">
                                    <input className="form-control" type="email" placeholder="Email here…" />
                                    <button type="submit" className="submit-btn btn"><img src="/img/icons/mail.svg"
                                            alt="" className="svg"/></button>
                                </div>
                            </form>

                            {/* Socials */}
                            <div className="socials d-flex align-items-center justify-content-center mt-30">
                                <NavLink to="https://www.twitter.com/" ><img
                                        src="/img/icons/twitter-round.svg" alt="" className="svg"/></NavLink>
                                <NavLink to="https://www.instagram.com/" ><img
                                        src="/img/icons/instagram-round.svg" alt="" className="svg"/></NavLink>
                                <NavLink to="https://www.pinterest.com/" ><img
                                        src="/img/icons/pinterest.svg" alt="" className="svg"/></NavLink>
                                <NavLink to="https://www.whatsapp.com/" ><img
                                        src="/img/icons/whatsapp.svg" alt="" className="svg"/></NavLink>
                            </div>
                            {/* End Socials */}
                        </div>
                    </div>
                    {/* End Card */}
                </div>
            </div>
        </div>
    </div>
    {/* End Coming Soon */}
    </>
  );
}

export default CommingSoon;
